import { Upload } from 'antd';
import styled from 'styled-components';

const UploadStyle = styled(Upload)`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

const UploadIcon = styled.img`
  cursor: pointer;
  width: 16px;
  height: 16px;
`;

export { UploadStyle, UploadIcon };
